<template>
    <div class="content">
      <!-- 左侧导航 -->
      <!-- <div class="side-nav" v-if="!layout.is_phone">
        <el-menu 
          :default-active="activeIndex"
          @select="handleSelect"
          class="nav-menu">
          <el-menu-item 
            v-for="(item, index) in cloudList"
            :key="index"
            :index="index.toString()">
            {{ item.title }}
          </el-menu-item>
        </el-menu>
      </div> -->
      
      <!-- 右侧内容 -->
      <div class="content">
        <el-timeline>
          <el-card 
            v-for="(item, index) in cloudList"
            :key="index"
            :id="'card-' + index"
            class="mb-4 section-card">
            <div slot="header">
              <span style="font-weight: 500;">{{ item.title }}</span>
            </div>
            <div style="width: 100%;">
              <el-row :gutter="20">
                <el-col 
                  v-for="(col, colIndex) in item.cols"
                  :key="colIndex"
                  :span="8" 
                  :xs="24" 
                  style="padding: 5px 10px;">
                    <div style="cursor: pointer;" @click="cancelModel(col)">{{ col.title }}</div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-timeline>
      </div>

         
        <el-dialog :close-on-click-modal="false"
			:title="$t('messageList.msgCon')"
			:visible.sync="dialogVisible"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			@close="closeDialog"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
                <span slot="title">
                    <span style="font-size: 1em;">{{ dialogTitle }}</span>
                </span>
                <div ref="dialogContent" style="max-height: 70vh; overflow: auto;">
                    <!-- 使用 v-html 渲染 HTML 内容 -->
                    <div v-html="dialogContent"></div>
                </div>
               

			<div slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">{{$t('system.cancel')}}</el-button>
			</div>
		</el-dialog>

  
    </div>
    
  </template>
  
  <script>
    import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
    export default {
        components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
        data() {
            return {
                dialogContent:'',
				dialogTitle:'',
                dialogTitleVisible: false,

                dialogVisible: false,

                activeIndex: '0',

                show2: true,

                preUrl: "data/questList", //列表地址

                cloudList: [ ]
            }
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll)
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll)
        },
        methods: {
            closeDialog() {
				this.dialogVisible = false;   // 關閉对话框
				this.dialogContent = '';      // 清空内容
				this.dialogTitle = '';      // 清空内容
			},
            cancelModel(row){
                this.dialogContent = row.content; // 设置要顯示的 HTML 内容
				this.dialogTitle = row.title; // 设置要顯示的 HTML 内容
                this.dialogVisible = true
            },
            handleSelect(index) {
                this.activeIndex = index
                const element = document.getElementById(`card-${index}`)
                if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                })
                }
            },
            getListResult(e) {
				this.cloudList = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
            handleScroll() {
                const cards = document.getElementsByClassName('section-card')
                const scrollPosition = window.scrollY + 100
        
                for (let i = cards.length - 1; i >= 0; i--) {
                const cardTop = cards[i].offsetTop
                if (scrollPosition >= cardTop) {
                    this.activeIndex = i.toString()
                    break
                }
                }
            }
        }
    }
</script>
  
  <style scoped>
  .transition-box{
    position: fixed;
    top: 0;
    left: 50%;
    width: 50%;
    z-index: 1000!important;
    background-color: red;
    height: 300px;
    padding: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1)
  }
  .container {
    display: flex;
    min-height: 100vh;
    background: #fff;
  }
  
  .side-nav {
    width: 200px;
    overflow: auto;
    background: #fff;
  }
  
  .nav-menu {
    border-right: none;
  }
  
  .content {
    flex: 1;
    padding: 20px;
  }
  
  .section-card {
    scroll-margin-top: 80px; /* 防止被固定导航遮挡 */
  }
  .el-timeline{
    padding: 0;
  }
  @media (max-width: 768px) {
    .side-nav {
      width: 100px;
    }
  }
  
  </style>